module.exports = __webpack_public_path__ + "static/media/07Demo Photo-ink.b182b83a.jpeg";